import type { ApplicationsContent } from '../types/ApplicationsContent';
import { createContentHook } from './createContentHook';

export const useApplicationsContent = createContentHook<ApplicationsContent>('/Applications');
